/** Preserve JSON integer values beyond JavaScript's safe range as decimal strings. */
export function parseApiJson(text: string): unknown {
  // Match whole JSON strings first, so digits inside quoted tokens are untouched.
  const safeText = text.replace(
    /"(?:\\[\s\S]|[^"\\])*"|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g,
    (token) => {
      if (token.startsWith('"') || !/^-?(?:0|[1-9]\d*)$/.test(token))
        return token;
      return Number.isSafeInteger(Number(token))
        ? token
        : JSON.stringify(token);
    },
  );
  return JSON.parse(safeText);
}
